import React from "react";

export interface ContextProviderProps {
    children: React.ReactNode
}

/**
 * Returns [useMyContext, MyContextProvider]
 */
export function createContext<A extends {} | null>(displayName: string) {

    const ctx = React.createContext<A | undefined>(undefined);
    ctx.displayName = displayName;

    function useCtx() {
        const c = React.useContext(ctx);
        if (c === undefined) {
            throw new Error(`No ${displayName} context provider`);
        }
        return c;
    }
    return [useCtx, ctx.Provider] as const;
}